/**
 * Makes a regex-like string that matches content surrounded by specific characters.
 * For example, `makeSurroundingRegExpString('*', '*')` would match "*text*"", capturing "text".
 *
 * @param {string} leftTrigger the string that should exist to the left of the content
 * @param {string} rightTrigger the string that should exist to the right of the content
 * @returns {string}
 */
function makeSurroundingRegExpString(
  leftTrigger: string,
  rightTrigger: string
) {
  const matchLeftSide = leftTrigger;
  const matchContent = `(?:(?!\\s${leftTrigger}).)+`;
  const matchRightSide = rightTrigger;

  return `${matchLeftSide}(${matchContent})${matchRightSide}`;
}

export function markRegexp(leftTrigger: string, rightTrigger = leftTrigger) {
  const checkBeginning = '(?:^|\\s)';
  return new RegExp(
    `${checkBeginning}(${makeSurroundingRegExpString(
      leftTrigger,
      rightTrigger
    )})$`
  );
}
